import {
  defaultConfigureStore,
  defaultStoreState,
  emptyState,
} from "shared/redux-store/defaultConfigureStore";
import fetcherMiddleware from "shared/redux-store/fetcherMiddleware";
import generalAppReducer from "shared/redux-store/generalAppReducer";

import { combineReducers } from "redux";
import reduceReducers from "reduce-reducers";
import { routerReducer } from "react-router-redux";

import routeFetchMapping from "./routeFetchMapping";

import StartupsDashboardReducer from "../dashboard/components/StartupsDashboard/StartupsDashboardReducer";
import startupsDashboardAppReducer from "../dashboard/startupsDashboardAppReducer";
import orderGroupsOverviewDataReducer from "../order-groups-overview/orderGroupsOverviewDataReducer";
import orderGroupsOverviewAppReducer from "../order-groups-overview/orderGroupsOverviewAppReducer";
import orderUnitsOverviewDataReducer from "../order-units-overview/orderUnitsOverviewDataReducer";
import orderUnitsOverviewAppReducer from "../order-units-overview/orderUnitsOverviewAppReducer";
import orderUnitDetailsDataReducer from "../order-unit-details/orderUnitDetailsDataReducer";
import orderUnitDetailsAppReducer from "../order-unit-details/orderUnitDetailsAppReducer";
import orderUnitWizardDataReducer from "../order-unit-details/orderUnitWizardDataReducer";
import orderUnitWizardAppReducer from "../order-unit-details/orderUnitWizardAppReducer";
import orderUnitEditorDataReducer from "../order-unit-editor/orderUnitEditorDataReducer";
import orderUnitEditorAppReducer from "../order-unit-editor/orderUnitEditorAppReducer";
import orderCreationDataReducer from "../order-creation/orderCreationDataReducer";
import orderCreationAppReducer from "../order-creation/orderCreationAppReducer";
import { orderCreationSlice } from "../order-creation/orderCreationSlice";
import welcomeAppReducer from "../../welcome/welcome/welcomeAppReducer";
import welcomeDataReducer from "../../welcome/welcome/welcomeDataReducer";
import digitalizedOrdersAppReducer from "../digitalized-orders/digitalizedOrdersAppReducer";
import digitalizedOrdersDataReducer from "../digitalized-orders/digitalizedOrdersDataReducer";

const appReducers = [
  generalAppReducer,
  startupsDashboardAppReducer,
  orderGroupsOverviewAppReducer,
  orderUnitsOverviewAppReducer,
  orderUnitDetailsAppReducer,
  orderUnitWizardAppReducer,
  orderUnitEditorAppReducer,
  orderCreationAppReducer,
  welcomeAppReducer,
  digitalizedOrdersAppReducer,
];

const dataReducers = [
  StartupsDashboardReducer,
  orderGroupsOverviewDataReducer,
  orderUnitsOverviewDataReducer,
  orderUnitDetailsDataReducer,
  orderUnitWizardDataReducer,
  orderUnitEditorDataReducer,
  orderCreationDataReducer,
  welcomeDataReducer,
  digitalizedOrdersDataReducer,
];

const rootReducer = combineReducers({
  app: reduceReducers(...appReducers),
  data: reduceReducers(...dataReducers),
  slices: combineReducers({ orderCreation: orderCreationSlice.reducer }),
  routing: routerReducer,
  // every top-level namespace needs its own reducer, so adding empty one here
  i18n: o => o || {},
});

const extraMiddlewares = [fetcherMiddleware(routeFetchMapping)];

export default function configureStore(initialState) {
  return defaultConfigureStore(
    rootReducer,
    defaultStoreState(initialState, emptyState),
    extraMiddlewares,
  );
}
